import * as React from "react"
import {Box, Typography} from "@mui/material";

import { useSkuWidthMediaQueries } from "@hooks";
import {ellipsisStyle} from "@utils";
import ShowDetails from "./ShowDetails";
import SkuLinkLabel from "./SkuLinkLabel";
import SkuLabel from "./SkuLabel";

export default function SkuInfoBlock({ sku, reference, category, brand, ean, productURL, asin, displayShowDetails=false, onClick, ellipsis=true, maxWidthEllipsis=false }) {
  const maxWidth = !!maxWidthEllipsis ? maxWidthEllipsis : useSkuWidthMediaQueries();
  return (
      <Box sx={{minWidth: "fit-content", whiteSpace: "nowrap", maxWidth: 500}}>
          {!productURL && <SkuLabel label={sku} ellipsis={ellipsis} maxWidth={maxWidth}/>}
          {productURL && <SkuLinkLabel url={productURL} skuName={sku} ellipsis={ellipsis} maxWidth={maxWidth}/>}
          {!!category && <Typography variant="caption" sx={{display: "block", color: "text.disabled"}}>
              <Box sx={{...(ellipsis && ellipsisStyle(maxWidth))}} title={ellipsis ? category : null}>
                  Category: {category}
              </Box>
          </Typography>}
          {!!brand && <Typography variant="caption" sx={{display: 'block', color: "text.disabled", whiteSpace: 'normal', wordBreak: 'break-word'}}>
              Brand: {brand}
          </Typography>}
          {!!ean && <Typography variant="caption" sx={{display: 'block', color: "text.disabled"}}>
              EAN: {ean}
          </Typography>}
          {!!reference && <Typography variant="caption" sx={{display: 'block', color: "text.disabled"}}>
              Reference: {reference}
          </Typography>}
          {!!asin && <Typography variant="caption" sx={{display: 'block', color: "text.disabled"}}>
              Asin: {asin}
          </Typography>}
          {displayShowDetails && <ShowDetails onClick={onClick}/>}
      </Box>
  );
}
